import moment from 'moment';
import React from 'react';

export default function TimeAgo({ date, className }: { date: string; className?: string }) {
  return (
    <span className={className} title={date}>
      {moment(date).fromNow()}
    </span>
  );
}
